import React, { useState } from 'react';

const LogarithmTable = () => {
  const [number, setNumber] = useState(10);
  const [logTable, setLogTable] = useState([]);

  const calculateLogTable = () => {
    const table = [];
    for (let i = 1; i <= 9; i++) {
      const baseNumber = number + i / 10;
      const logValue = Math.log10(baseNumber).toFixed(5);
      const meanDifference = (Math.log10(baseNumber + 0.01) - logValue).toFixed(5);
      table.push({ baseNumber, logValue, meanDifference });
    }
    setLogTable(table);
  };

  return (
    <div>
      <h2>Logarithm Table Generator</h2>
      <label htmlFor="numberInput">Enter a number (10-99): </label>
      <input
        type="number"
        id="numberInput"
        min="10"
        max="99"
        value={number}
        onChange={(e) => setNumber(parseInt(e.target.value))}
      />
      <button onClick={calculateLogTable}>Generate Table</button>

      {logTable.length > 0 && (
        <table border="1" style={{ marginTop: '20px', borderCollapse: 'collapse' }}>
          <thead>
            <tr>
              <th>Base Number</th>
              <th>Log Value</th>
              <th>Mean Difference</th>
            </tr>
          </thead>
          <tbody>
            {logTable.map((row, index) => (
              <tr key={index}>
                <td>{row.baseNumber.toFixed(1)}</td>
                <td>{row.logValue}</td>
                <td>{row.meanDifference}</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default LogarithmTable;
